/**
 * The size variations for the teaching bubble component
 * @public
 */
export const TeachingBubbleSizes = {
    small: "small",
    medium: "medium",
    large: "large"
};
/**
 * The placement variations for the teaching bubble component
 * @public
 */
export const TeachingBubblePlacements = {
    top: "top",
    topStart: "top-start",
    topEnd: "top-end",
    bottom: "bottom",
    bottomStart: "bottom-start",
    bottomEnd: "bottom-end",
    left: "left",
    leftStart: "left-start",
    leftEnd: "left-end",
    right: "right",
    rightStart: "right-start",
    rightEnd: "right-end"
};
/**
 * TeachingBubble event names
 * @public
 */
export const TeachingBubbleEventNames = {
    openChange: "open-change",
    dismiss: "dismiss"
};
//# sourceMappingURL=teaching-bubble.options.js.map